import { createSlice } from '@reduxjs/toolkit';

import { getAuthUserInfo } from './AuthUserInfoThunks';

export const initialState = {
    user: null,
    loading: false,
    error: false,
};

const AuthUserInfoSlice = createSlice({
    name: 'authUserInfo',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getAuthUserInfo.pending, state => {
            state.error = false;
            state.loading = true;
        });
        builder.addCase(getAuthUserInfo.fulfilled, (state, { payload }) => {
            state.user = payload.user;
            state.loading = false;
        });
        builder.addCase(getAuthUserInfo.rejected, (state, { payload }) => {
            state.error = true;
            state.loading = false;
            alert(payload);
        });
    },
});

export const AuthUserInfoReducer = AuthUserInfoSlice.reducer;
export const AuthUserInfoActions = {
    ...AuthUserInfoSlice.actions,
    getAuthUserInfo,
};
